export default "__VITE_ASSET__RVJfoQoJ__"